import { z } from "zod"
import type { Plan } from "./plans"

export const TABS = ["all", "active", "drafts", "completed"] as const

export type Tab = (typeof TABS)[number]

export const plansSearchSchema = z.object({
  tab: z.enum(TABS).optional().catch(undefined),
  search: z.string().optional().catch(undefined),
})

export type PlansSearch = z.infer<typeof plansSearchSchema>

export function tabLabel(tab: Tab): string {
  switch (tab) {
    case "all":
      return "All"
    case "active":
      return "Active"
    case "drafts":
      return "Drafts"
    case "completed":
      return "Completed"
  }
}

function inTab(plan: Plan, tab: Tab): boolean {
  switch (tab) {
    case "all":
      return true
    case "active":
      return plan.status === "in-progress" || plan.status === "scheduled"
    case "drafts":
      return plan.status === "draft"
    case "completed":
      return plan.status === "completed"
  }
}

export function shownPlans(plans: Plan[], search: PlansSearch): Plan[] {
  const query = search.search?.trim().toLowerCase() ?? ""
  return plans
    .filter((plan) => inTab(plan, search.tab ?? "all"))
    .filter(
      (plan) =>
        !query ||
        [plan.id, plan.tail, plan.model, plan.title, plan.source].some(
          (value) => value.toLowerCase().includes(query),
        ),
    )
}
